export const INDIVIDUAL_TAB_ID = 'individual';
